import { createContext, ReactNode, useContext } from "react"
import { useSelector } from "react-redux"
import { RootState } from "src/store/store"

const MaxHeightContext = createContext<{
    maxHeight: string
}>({ maxHeight: "" })

export const MaxHeightProvider = ({ children }: { children: ReactNode }) => {
    const { roomsDimensions } = useSelector((state: RootState) => state.rooms)
    const maxHeight = roomsDimensions?.x ? `calc(calc(92vh - 200px) / ${roomsDimensions.x})` : ""

    return <MaxHeightContext.Provider value={{ maxHeight }}>{children}</MaxHeightContext.Provider>
}

export const useMaxHeightContext = () => {
    const { maxHeight } = useContext(MaxHeightContext)
    return { maxHeight }
}
